import { useEffect, useState } from 'react'

const FRENCH_TIME_ZONES = [
  'Europe/Paris', 'Indian/Reunion', 'Indian/Mayotte', 'America/Martinique', 
  'America/Guadeloupe', 'America/French_Guiana', 'Pacific/Noumea', 
  'Pacific/Tahiti', 'Pacific/Wallis'
];

const isFrenchLanguage = (languages) => 
  languages.some(lang => lang.toLowerCase().startsWith('fr'));

const hasFrenchNumbering = () => {
  const numberFormat = new Intl.NumberFormat().format(1000.50);
  return numberFormat.includes(' ') && numberFormat.includes(',');
};

const isFrenchTimeZone = (timeZone) => FRENCH_TIME_ZONES.includes(timeZone);

function FrenchSystemCheck({ children }) {
  const [isFrenchDevice, setIsFrenchDevice] = useState(false);

  useEffect(() => {
    const checkFrenchDevice = () => {
      const systemLanguage = navigator.language;
      const systemLanguages = navigator.languages || [];
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const isFrench = isFrenchLanguage([systemLanguage, ...systemLanguages]) &&
                       isFrenchTimeZone(timeZone) &&
                       hasFrenchNumbering();

      setIsFrenchDevice(isFrench);
    };

    checkFrenchDevice();
    window.addEventListener('languagechange', checkFrenchDevice);

    return () => {
      window.removeEventListener('languagechange', checkFrenchDevice);
    };
  }, []);

  if (!isFrenchDevice) {
    return null;
  }

  return <>{children}</>;
}

export default FrenchSystemCheck;
